import React, { useCallback, useState } from 'react';
import * as Yup from 'yup';
import { FiArrowLeft } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import { Box, Slide, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import useStyles from './styles';

import getValidationErrors, { IErrors } from '../../utils/getValidationErrors';

import BarberShopTitle from '../../components/BarberShopTitle';
import CustomForm from '../../components/CustomForm';
import { form, initialData, schema } from './form';
import userService from '../../services/userService';
import parseApiErrors from '../../utils/parseApiErrors';
import LoadingButton from '../../components/LoadingButton';

interface SignUpFormData {
  firstName: string;
  lastName: string;
  email: string;
  whatsapp: string;
  password: string;
  password2: string;
}

const SignUp: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const [errors, setErrors] = useState<IErrors>(initialData);
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState<SignUpFormData>(initialData);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        await schema.validate(data, {
          abortEarly: false,
        });

        await userService.signUp({
          first_name: data.firstName,
          last_name: data.lastName,
          email: data.email,
          whatsapp: data.whatsapp,
          password: data.password,
          password2: data.password2,
          group: ['Employee', 'Owner'],
        });

        // toast.success('Cadastro realizado com sucesso');
        history.push('/');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errorsValidate = getValidationErrors(err);

          setErrors(errorsValidate);

          return;
        }

        if (err.response.status === 400) {
          setErrors(parseApiErrors(err.response.data));
          return;
        }

        toast.error('Ocorreu ao realizar o cadastro. Tente novamente');
      } finally {
        setIsLoading(false);
      }
    },
    [data, history],
  );

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setData({
        ...data,
        [e.target.name]: e.target.value,
      });
      setErrors({
        ...errors,
        [e.target.name]: '',
      });
    },
    [data, errors],
  );

  return (
    <Box display="flex" justifyContent="center" maxWidth="600px" margin="auto">
      <Slide in direction="left">
        <Box
          p={3}
          display="flex"
          flexDirection="column"
          width="100%"
          alignItems="center"
          textAlign="center"
          className={classes.root}
        >
          <BarberShopTitle title="Agendfly" />
          <Typography variant="h5" className={classes.title}>
            Faça seu cadastro
          </Typography>
          <form onSubmit={handleSubmit} className={classes.form}>
            <CustomForm
              onChange={handleChange}
              data={data}
              form={form}
              errors={errors}
            />
            <LoadingButton
              loading={isLoading}
              variant="contained"
              color="primary"
              className={classes.submitButton}
              type="submit"
              size="large"
              fullWidth
            >
              Cadastrar
            </LoadingButton>
          </form>
          <Link to="/">
            <FiArrowLeft />
            Voltar para Login
          </Link>
        </Box>
      </Slide>
    </Box>
  );
};

export default SignUp;
